import { createSlice } from "@reduxjs/toolkit";

import { fetchPipelineByOwner } from "./actions";

export const initialState = {
  data: null,
  isLoading: false,
  error: null,
};

const DEFAULT_ERROR = "Failed to load pipeline by owner";

const pipelineByOwnerSlice = createSlice({
  name: "pipelineByOwner",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchPipelineByOwner.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchPipelineByOwner.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(fetchPipelineByOwner.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error?.message ?? DEFAULT_ERROR;
      });
  },
});

export default pipelineByOwnerSlice.reducer;
